import { useState } from 'react';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);

  return {
    loading,
    setLoading,
  };
};

export default useCustomHook;
